import React from "react";
import { IconProps } from "../icon";

export const MarkerPin_03Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 22c1-5 8-5.582 8-12a8 8 0 10-16 0c0 6.418 7 7 8 12z"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 13a3 3 0 100-6 3 3 0 000 6z"
    />
  </svg>
);
